// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"d508b05d","161":"7111c167","605":"c2da84ae","980":"bc80ca13"}[chunkId] + ".chunk.js";
};